import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { TemplateService } from '../../services/template.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
var RDSendReportComponent = (function () {
    function RDSendReportComponent(apiService, modalService, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.allDocumentType = [];
        this.allBranchSelected = [];
        this.selectedValues = [];
        this.currentPage = 1;
        this.loading = false;
        this.no_data = true;
        this.value = 0;
        this.sum_docs_count = 0;
        this.errorMsg = '';
        this.resendAllPendingMessage = '';
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.yearList = [];
        this.index = 0;
        this.branchList = null;
        this.allBranchList = null;
        this.docTypeList = null;
        this.loading_excel_report = false;
        this.is_TH = false;
        this.sortAscending = true;
        this.filterAcceptedSelected = false;
        this.filterRejectedSelected = false;
        this.filterPendingSelected = false;
    }
    RDSendReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isPageChanged = false;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            if (event.lang === 'th') {
                _this.is_TH = true;
            }
            if (event.lang === 'en') {
                _this.is_TH = false;
            }
            _this.populateDropdown();
        });
        this.populateDropdown();
        this.loadTexts();
        this.searchData();
    };
    RDSendReportComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.selectedCompany = null;
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        // FIXME document type upon page refresh
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    RDSendReportComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate === _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    RDSendReportComponent.prototype.loadTexts = function () {
        var _this = this;
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            var documentData = _this.template.getDropdown();
            _this.rdDocumentType = documentData;
            documentData[0] = { label: _this.translate.instant('COMMON.ALL'), value: null };
            _this.selectedRdDocumentType = null;
            _this.loadInput();
        });
    };
    RDSendReportComponent.prototype.populateDropdown = function () {
        this.monthListDropdown = [];
        this.monthListDropdown.push({ label: this.translate.instant('MONTH.JANUARY'), value: 1 }, { label: this.translate.instant('MONTH.FEBRUARY'), value: 2 }, { label: this.translate.instant('MONTH.MARCH'), value: 3 }, { label: this.translate.instant('MONTH.APRIL'), value: 4 }, { label: this.translate.instant('MONTH.MAY'), value: 5 }, { label: this.translate.instant('MONTH.JUNE'), value: 6 }, { label: this.translate.instant('MONTH.JULY'), value: 7 }, { label: this.translate.instant('MONTH.AUGUST'), value: 8 }, { label: this.translate.instant('MONTH.SEPTEMBER'), value: 9 }, { label: this.translate.instant('MONTH.OCTOBER'), value: 10 }, { label: this.translate.instant('MONTH.NOVEMBER'), value: 11 }, { label: this.translate.instant('MONTH.DECEMBER'), value: 12 });
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
        this.defaultMonth = currentDate.getMonth() + 1;
        this.defaultYear = thisYear;
    };
    RDSendReportComponent.prototype.canUserDownloadDoc = function () {
        return this.authService.isAccountantAdmin();
    };
    RDSendReportComponent.prototype.pageChanged = function () {
        this.isPageChanged = true;
        this.searchData();
    };
    RDSendReportComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    RDSendReportComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    RDSendReportComponent.prototype.searchBranch = function (event) {
        var _this = this;
        if (this.branchList == null) {
            this.apiService.getBranch().subscribe(function (data) {
                _this.branchList = data;
                _this.branchSuggest = _this.filterData(event.query, 'full_name', _this.branchList);
            });
        }
        else {
            this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
    };
    RDSendReportComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    RDSendReportComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    RDSendReportComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    RDSendReportComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    RDSendReportComponent.prototype.searchData = function () {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        this.allBranchSelected = [];
        this.allDocumentType = [];
        _.forEach(this.branch, function (data) {
            // this.allBranchSelected = [];
            _this.allBranchSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        var params = {
            no_accepted: this.notAccepted != null ? this.notAccepted : '',
            month: this.selectedMonth || '',
            year: this.selectedYear || '',
            document_number: this.documentNumber || '',
            company_id: this.selectedCompany || '',
            branch_id: this.selectedBranch ? [this.selectedBranch] : '',
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType || '',
            status: this.selectedStatus || '',
        };
        if (this.currentPage > 1) {
            params['page'] = this.currentPage;
        }
        if (this.sortBy && this.sortMode) {
            params['sort'] = this.sortBy;
            params['sort_type'] = this.sortMode;
        }
        var sniffTargetArr = [];
        if (this.documentNumber) {
            sniffTargetArr.push('FILTER.DOCUMENT-NUMBER');
        }
        if (this.selectedRdDocumentType) {
            sniffTargetArr.push('FILTER.DOCUMENT-TYPE');
        }
        if (this.defaultMonth !== this.selectedMonth) {
            sniffTargetArr.push('FILTER.MONTH');
        }
        if (this.defaultYear !== this.selectedYear) {
            sniffTargetArr.push('FILTER.YEAR');
        }
        if (this.notAccepted) {
            sniffTargetArr.push('RD-SEND-REPORT.ONLY-NO-ACCEPTED');
        }
        this.apiService.getRDSendReport(params).subscribe(function (result) {
            // Check if result object is empty
            if (Object.keys(result).length != 0 || result.constructor != Object) {
                _this.loading = false;
                _this.tableData = result.results;
                _this.tableDataDisplay = _this.tableData;
                _this.no_data = _.isEmpty(_this.tableData);
                _this.totalItems = result.count;
                _this.statistic = result.statistic;
                _this.selectedValues = [];
                for (var i = 0; i < _this.tableData.length; i++) {
                    _this.selectedValues.push(false);
                }
            }
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
        this.getLatestManualResendTime();
        if (!this.isPageChanged) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    RDSendReportComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedStatus = null;
        this.searchData();
    };
    RDSendReportComponent.prototype.searchStatus = function (status) {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedStatus = status;
        this.searchData();
    };
    RDSendReportComponent.prototype.getLatestManualResendTime = function () {
        var _this = this;
        var data = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.apiService.getLatestManualResendTime(data).subscribe(function (result) {
            _this.canManualResend = result.can_manual_resend;
        }, function (error) {
            console.log('error', error);
        });
    };
    RDSendReportComponent.prototype.closeResendAllPending = function () {
        this.modal.close();
        this.searchButtonClicked();
    };
    RDSendReportComponent.prototype.resendAllPending = function (content) {
        var _this = this;
        var data = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
        this.apiService.resendAllPendingEbxml(data).subscribe(function (res) {
            _this.resendAllPendingMessage = res.msg;
        }, function (error) {
            console.log(error);
        });
    };
    RDSendReportComponent.prototype.clearData = function () {
        this.startDate = new Date();
        this.endDate = new Date();
        this.selectedMonth = this.defaultMonth;
        this.selectedYear = this.defaultYear;
        this.selectedCompany = null;
        this.selectedVerifiedAccount = null;
        this.selectedHomeproGroup = null;
        this.branch = null;
        this.documentNumber = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.notAccepted = false;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.searchButtonClicked();
    };
    RDSendReportComponent.prototype.clearBranch = function () {
        this.allBranchSelected = [];
    };
    RDSendReportComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    RDSendReportComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' +
                this.translate.instant('COMMON.CORRECT');
        }
    };
    RDSendReportComponent.prototype.DownloadExcelReport = function () {
        this.loading_excel_report = true;
        // const params = {
        //   month: this.selectedMonth,
        //   year: this.selectedYear,
        // };
        // this.apiService.getExcelReport(params).subscribe(
        //   (obj) => {
        //     const filename = 'tax_report_' + this.selectedMonth + '_' + this.selectedYear  + '.xlsx';
        //     this.apiService.createDownloadFile(obj, filename);
        //     this.loading_excel_report = false;
        //   },
        //   error => {
        //     this.loading_excel_report = false;
        //   }
        // );
        this.loading_excel_report = false;
    };
    RDSendReportComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
        // this.searchData();
    };
    // resend function is not used now
    RDSendReportComponent.prototype.resend = function (taxDataId) {
        var _this = this;
        this.apiService.resendToRD(taxDataId).subscribe(function (res) {
            _this.searchData();
        }, function (error) {
            console.log(error);
        });
    };
    RDSendReportComponent.prototype.filterAccepted = function () {
        if (this.filterAcceptedSelected === false) {
            this.filterAcceptedSelected = true;
            this.searchStatus('rd_accepted');
        }
        else {
            this.filterAcceptedSelected = false;
            this.searchStatus(null);
        }
    };
    RDSendReportComponent.prototype.filterRejected = function () {
        if (this.filterRejectedSelected === false) {
            this.filterRejectedSelected = true;
            this.searchStatus('rd_rejected');
        }
        else {
            this.filterRejectedSelected = false;
            this.searchStatus(null);
        }
    };
    RDSendReportComponent.prototype.filterPending = function () {
        if (this.filterPendingSelected === false) {
            this.filterPendingSelected = true;
            this.searchStatus('sent_to_service_provider');
        }
        else {
            this.filterPendingSelected = false;
            this.searchStatus(null);
        }
    };
    RDSendReportComponent.prototype.sortColumn = function (columnName) {
        if (this.sortAscending) {
            this.sortAscending = false;
            this.tableDataDisplay = this.tableData.sort(function (a, b) {
                // handle null value
                if (a[columnName] !== null && b[columnName] === null) {
                    return 1;
                }
                if (a[columnName] === null && b[columnName] !== null) {
                    return -1;
                }
                if (a[columnName] === null && b[columnName] === null) {
                    return 0;
                }
                // handle status Accepted, Rejected, and Pending
                if (columnName === 'ebxml_status') {
                    // Accepted vs. Accepted
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_accepted') {
                        return 0;
                    }
                    // Accepted vs. Pending
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'sent_to_service_provider') {
                        return 1;
                    }
                    // Accepted vs. Error
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_error') {
                        return 1;
                    }
                    // Accepted vs. Ack
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_acknowledged') {
                        return 1;
                    }
                    // Accepted vs. Rejected
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_rejected') {
                        return 1;
                    }
                    // Pending vs Accepted
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_accepted') {
                        return -1;
                    }
                    // Pending vs Error
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_error') {
                        return -1;
                    }
                    // Pending vs Ack
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_acknowledged') {
                        return -1;
                    }
                    // Pending vs Pending
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'sent_to_service_provider') {
                        return 0;
                    }
                    // Pending vs Rejected
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_rejected') {
                        return 1;
                    }
                    // Rejected vs Accepted
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_accepted') {
                        return -1;
                    }
                    // Rejected vs Pending
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'sent_to_service_provider') {
                        return 1;
                    }
                    // Rejected vs Error
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_error') {
                        return 1;
                    }
                    // Rejected vs Ack
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_acknowledged') {
                        return 1;
                    }
                    // Rejected vs Rejected
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_rejected') {
                        return 0;
                    }
                    // Error vs Accepted
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_accepted') {
                        return -1;
                    }
                    // Error vs Pending
                    if (a[columnName] === 'rd_error' && b[columnName] === 'sent_to_service_provider') {
                        return 1;
                    }
                    // Error vs Error
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_error') {
                        return 0;
                    }
                    // Error vs Ack
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_acknowledged') {
                        return -1;
                    }
                    // Error vs Rejected
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_rejected') {
                        return -1;
                    }
                    // Ack vs Accepted
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_accepted') {
                        return -1;
                    }
                    // Ack vs Pending
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'sent_to_service_provider') {
                        return 1;
                    }
                    // Ack vs Error
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_error') {
                        return 1;
                    }
                    // Ack vs Ack
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_acknowledged') {
                        return 0;
                    }
                    // Ack vs Rejected
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_rejected') {
                        return -1;
                    }
                }
                // handle RD Acknowledge and Sent to SP
                if (columnName === 'rd_acknowledged' || columnName === 'sent_to_rd') {
                    return a['ebxml_steps'][columnName] < b['ebxml_steps'][columnName] ? -1 : a['ebxml_steps'][columnName] > b['ebxml_steps'][columnName] ? 1 : 0;
                }
                return a[columnName] < b[columnName] ? -1 : a[columnName] > b[columnName] ? 1 : 0;
            });
        }
        else {
            this.sortAscending = true;
            this.tableDataDisplay = this.tableData.sort(function (a, b) {
                // handle null value
                if (a[columnName] !== null && b[columnName] === null) {
                    return -1;
                }
                if (a[columnName] === null && b[columnName] !== null) {
                    return 1;
                }
                if (a[columnName] === null && b[columnName] === null) {
                    return 0;
                }
                // handle status Accepted, Rejected, and Pending
                if (columnName === 'ebxml_status') {
                    // Accepted vs. Accepted
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_accepted') {
                        return 0;
                    }
                    // Accepted vs. Pending
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'sent_to_service_provider') {
                        return -1;
                    }
                    // Accepted vs. Error
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_error') {
                        return -1;
                    }
                    // Accepted vs. Ack
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_acknowledged') {
                        return -1;
                    }
                    // Accepted vs. Rejected
                    if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_rejected') {
                        return -1;
                    }
                    // Pending vs Accepted
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_accepted') {
                        return 1;
                    }
                    // Pending vs Error
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_error') {
                        return 1;
                    }
                    // Pending vs Ack
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_acknowledged') {
                        return 1;
                    }
                    // Pending vs Pending
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'sent_to_service_provider') {
                        return 0;
                    }
                    // Pending vs Rejected
                    if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_rejected') {
                        return -1;
                    }
                    // Rejected vs Accepted
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_accepted') {
                        return 1;
                    }
                    // Rejected vs Pending
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'sent_to_service_provider') {
                        return -1;
                    }
                    // Rejected vs Error
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_error') {
                        return -1;
                    }
                    // Rejected vs Ack
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_acknowledged') {
                        return -1;
                    }
                    // Rejected vs Rejected
                    if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_rejected') {
                        return 0;
                    }
                    // Error vs Accepted
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_accepted') {
                        return 1;
                    }
                    // Error vs Pending
                    if (a[columnName] === 'rd_error' && b[columnName] === 'sent_to_service_provider') {
                        return -1;
                    }
                    // Error vs Error
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_error') {
                        return 0;
                    }
                    // Error vs Ack
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_acknowledged') {
                        return 1;
                    }
                    // Error vs Rejected
                    if (a[columnName] === 'rd_error' && b[columnName] === 'rd_rejected') {
                        return 1;
                    }
                    // Ack vs Accepted
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_accepted') {
                        return 1;
                    }
                    // Ack vs Pending
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'sent_to_service_provider') {
                        return -1;
                    }
                    // Ack vs Error
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_error') {
                        return -1;
                    }
                    // Ack vs Ack
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_acknowledged') {
                        return 0;
                    }
                    // Ack vs Rejected
                    if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_rejected') {
                        return 1;
                    }
                }
                // handle RD Acknowledge and Sent to SP
                if (columnName === 'rd_acknowledged' || columnName === 'sent_to_rd') {
                    return a['ebxml_steps'][columnName] < b['ebxml_steps'][columnName] ? 1 : a['ebxml_steps'][columnName] > b['ebxml_steps'][columnName] ? -1 : 0;
                }
                return a[columnName] < b[columnName] ? 1 : a[columnName] > b[columnName] ? -1 : 0;
            });
        }
    };
    RDSendReportComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'RD_SUMMARY',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    RDSendReportComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return RDSendReportComponent;
}());
export { RDSendReportComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.component.ts.pre-build-optimizer.js